export default "__VITE_ASSET__e3f869ac__"